import HomeContainer from '../Container/HomeContainer2'
import React, { Fragment, useState, useEffect } from 'react'
import { GridColumn, GridRow, Icon, Message } from 'semantic-ui-react'
import JobComponent from './JobComponent'
import RecentFeedback from './RecentFeedback'
import NextExpectedPayment from './NextExpectedPayment'
import Spinner from '../../Components/Spinner/Spinner'
import '../Home/Home.css'
import ProfileBox from '../../Components/ProfileBox/ProfileBox'
import '../College/SearchTeacher.css'
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { Grid, Responsive } from 'semantic-ui-react'
import './Dashboard.css'
import DashboardLink from './DashboardLink'
import Tour from 'reactour'
import { handleMultiDateBookings, submitResponse } from '../Bookings2/Helper'
import { Link } from 'react-router-dom'
import { API } from '../../API'
import { teacherResponse, getClass } from '../../Helper'
import Moment from 'react-moment'
import { Carousel } from '3d-react-carousal';
import MobileCarousel from 'nuka-carousel';
import { getBadges } from "../../Helper";
import Modal from "../../Components/Modal/Modal";


//Redux
import { connect } from 'react-redux'
import Auth from '../../Auth/Auth'
import HoverIcon from '../../Components/FormField/HoverIcon-nova'
import {round} from "@popperjs/core/lib/utils/math";
import { useMediaQuery } from "react-responsive";

function Dashboard(props) {
  const [user, setUser] = useState(props.user)
  let [allBookings, setAllBookings] = useState([])
  // let [allCampus, setAllCampus] = useState([]);
  // let [allInst, setAllInst] = useState([]);
  let [showTour, setShowTour] = useState(
    (props.location.state && props.location.state.firstTime) || false,
  )
  let [bdCheck, setBdCheck] = useState(false)
  let [newBookingsList, setNewBookings] = useState([])
  let [bookingNotif, showBookingNotif] = useState(false)
  let isAllBookinngsLoaded = false
  let [bookingLoaded, setBookingLoaded] = useState(false);
  const isMobile = useMediaQuery({ query: `(max-width: 769px)` });

  const [bookingCampuses, setBookingCampuses] = useState([])
  const [bookingInst, setBookingInst] = useState([])
  const [badges, setBadges] = useState([])
  const [showPaylevelModal, setShowPaylevelModal] = useState(true);

  useEffect(() => {
    if (!window.localStorage.token || !Auth.authenticated || !props) {
      const path = {
        pathname: '/login',
      }
      props.history.push(path)
    }
    if (!isAllBookinngsLoaded) getAllBookingsOfUser()
    // getAllCampus();
    // getAllInst();
  }, [isAllBookinngsLoaded])

  useEffect(() => {
    if (props.user) {
      API.verifyBankDetails()
        .then((res) => {
          setBdCheck(res.data.bank_details)
        })
        .catch((err) => {
          console.log(err)
        })
    }

  }, [props.user])

  useEffect(() => {
    fetchFeedbackBadge()
  }, [])

  let size = 2

  const fetchFeedbackBadge = async () => {
    try {
      const response = await API.getFeedbackBadgeByTeacherID(user?._id);
      let badges = [];
      const listBadges = Object.keys(response?.data?.data);
      const listCounts = Object.values(response.data.data);
      if (listBadges.length > 0) {
        listBadges.map((item, index) => {
          if (listCounts[index] > 0)
            badges.push({ title: item, count: listCounts[index] });
        });
        setBadges(badges);
      } else {
        const badges = getBadges();
        setBadges(
          badges
            .slice(0, 5)
            ?.map((badge) => ({ title: badge.badge_title, count: 0 }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getBookingInst = async (campuses) => {
    const instIDs = campuses?.map(campus => campus?.institution_id)
    const uniqueInstIDs = [...new Set(instIDs)]
    const result = await API.getMultipleInstitutionById(uniqueInstIDs)
    setBookingInst(result?.data || [])
  }

  const getAllBookingCampuses = async (bookings) => {
    const campusIDs = bookings.map(booking => booking.campus_id)
    const uniqueIDs = [...new Set(campusIDs)]
    const campuses = await API.getMultipleCampusById(uniqueIDs)
    setBookingCampuses(campuses?.data || [])
    getBookingInst(campuses?.data || [])
  }

  const getAllBookingsOfUser = () => {
    //Get access to all the bookings of the current user
    setBookingLoaded(false);
    API.getAllBookingsByTeacherID(user._id, ['rejected', 'cancelled'])
      .then(function (result) {
        const today = new Date()
        const today_date = today.toISOString().slice(0, 10)
        const today_time = `${today
          .getHours()
          .toString()
          .padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`
        let list = handleMultiDateBookings(result.data, user._id)
          .filter((booking) => {
            const compare_date =
              booking.end_booking_date || booking.booking_date
            return (
              compare_date > today_date ||
              (compare_date === today_date && booking.end_time > today_time)
            )
          })
          .sort((a, b) => {
            return a.booking_date > b.booking_date ? 1 : -1
          })
          .filter((booking) => {
            return !booking.cancelled_by_inst
          })
        // console.log(result.data)

        isAllBookinngsLoaded = true
        // setAllBookings(list);

        let newBookings = []
        let respondedBookings = []

        // const newBookings = list.filter((booking) => booking.teacher_response === teacherResponse.not_responded);
        list.forEach((booking) => {
          if (booking.teacher_response === teacherResponse.not_responded) {
            newBookings.push(booking)
          } else {
            respondedBookings.push(booking)
          }
        })

        const sortedBookings = newBookings.concat(respondedBookings)

        setAllBookings(sortedBookings)
        setNewBookings(newBookings)
        if (newBookings.length) showBookingNotif(true)
        setBookingLoaded(true);
        getAllBookingCampuses(sortedBookings)
      })
      .catch(function (err) {
        console.log(err.response)
      })
  }

  if (user) {
    // const segmentSize = "large";
    // const segmentColor = "teal";

    const img_check = () => {
      if (user.img_url) {
        if (user.img_url != '') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }

    const avai_check =
      user.rules &&
      user.rules.length > 0 &&
      Object.keys(user.rules[0]).length > 0

    const perDetail_check = () => {
      if (
        !user.first_name ||
        !user.last_name ||
        !user.contact_number ||
        !user.address_line1 ||
        !user.suburb ||
        !user.state ||
        !user.postcode
      ) {
        return false
      } else {
        return true
      }
    }

    const id_check = () => {
      if (
        !user.id_document_type ||
        !user.identification_document_number ||
        !user.issuing_place ||
        !user.id_document_expiry ||
        !user.identification_filename
      ) {
        return false
      } else {
        return true
      }
    }

    const referee_check = user.referees.length > 0

    const quali_check = () => {
      if (user.qualifications) {
        if (user.qualifications.length > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }

    const vet_quals_check = () => {
      let result = false

      if (
        (user.vet_training_quals && user.vet_training_quals.length > 0) ||
        (user.vet_industry_quals && user.vet_industry_quals.length > 0)
      ) {
        result = true
      }

      return result
    }

    const proEx_check = user.professional_experience.length > 0

    const vet_exp_check = () => {
      let result = false

      if (
        (user.vet_training_exp && user.vet_training_exp.length > 0) ||
        (user.vet_industry_exp && user.vet_industry_exp.length > 0)
      ) {
        result = true
      }

      return result
    }

    const workLocation_check = () => {
      return !(!user.preferred_country1 || !user.preferred_city1);
    }

    const get_progress = () => {
      var progress = 0
      const pro_list = [
        img_check(),
        avai_check,
        id_check(),
        referee_check,
        perDetail_check(),
        bdCheck,
        workLocation_check(),
      ]

      if (user.is_elt === true) {
        pro_list.push(quali_check(), proEx_check)
      }

      if (user.is_vet === true) {
        pro_list.push(vet_quals_check(), vet_exp_check())
      }

      for (var i = 0; i < pro_list.length; i++) {
        if (pro_list[i]) {
          progress += 1
        }
      }
      progress = round((progress / pro_list.length) * 100)
      return progress
    }

    var progress = get_progress()

    const handleBookings = (newBookings) => {
      setAllBookings(newBookings)
    }

    const tourSteps = [
      {
        content:
          // "New to ReadyTeacher? If you're here to apply for a job, here's how to set up:",
          'Welcome to ReadyTeacher! If you saw a job advertised that you’d like to apply for, here’s how to complete the application process.',
      },
      {
        selector: '.dash-tour-resume',
        // content: "Update your resume to show your work experience...",
        content:
          'Let’s start with your Resume. Add as much information as you can, and make sure you upload the right documents at each stage.',
      },
      {
        selector: '.dash-tour-profile',
        content:
          'Go to your Profile next. Fill in the courses you can deliver on the right. This will help your Profile to match with searches made by education providers.',
      },
      {
        content: "Next, let's move onto the quick action links.",
        action: () =>
          document
            .querySelector('.quick-action-links')
            .scrollIntoView({ block: 'center' }),
      },
      {
        selector: '.set-availability-link',
        content:
          'You can set your availability for work here and update it at any time.',
      },
      {
        selector: '.view-job-list-link',
        content:
          'You can view the job list here which contains all your past and future bookings.',
      },
      {
        selector: '.search-apply-link',
        content:
          'Click on ‘Search & Apply’ on your Dashboard. There, you will see a list of current openings. Click on ‘Read more + Apply’. ',
      },
    ]

    const classList = getClass()
    const openTour = () => {
      setShowTour(true)
    }

    return (
      <HomeContainer
        tabDashboardActive={true}
        tabProfileActive={false}
        user={user}
        isViewAsTeacher={true}
        hideViewBar={true}
      >
        <Tour
          showCloseButton={false}
          accentColor="#79cbca"
          className="tourContent"
          steps={tourSteps}
          isOpen={showTour}
          onRequestClose={() => setShowTour(false)}
        >
          <div className="tour-dot" onClick={() => setShowTour(false)} />
        </Tour>

        <div className="">
          <div
            className="guide-tour-icon"
          >
            <HoverIcon
              icon="info"
              circular
              inverted
              className="search-help-icon"
              onClick={openTour}
              text="Click for guide"
            />
          </div>
          {/* <div className='my-10 top-upcoming-classes-spacing'> */}
          <div className={allBookings.length === 0 || allBookings.length === 1 ? '' : 'dashboard-bookings'}>
            {bookingLoaded && (!allBookings.length || (!user.admin && bookingCampuses?.length && bookingInst?.length)) ? (
              allBookings.length === 0 ? (
                <div className="row flex-row mx-0 upcoming-inner">
                  <div className="col-lg-6 center-single-job">
                    <ProfileBox header={user?.is_childhood_teacher ? "Upcoming Shift" : "Upcoming Class"} topUpcomingClass={true}/>
                  </div>
                </div>
              ) : allBookings.length === 1 ?
                (<div
                  className='col-lg-6 center-single-job'
                  key={allBookings[0]._id}
                >
                  <JobComponent
                    job={allBookings[0]}
                    bookings={allBookings}
                    campuses={bookingCampuses}
                    insts={bookingInst}
                    // campuses={allCampus}
                    // insts={allInst}
                    response={true}
                    submitResponse={(...args) => {
                      setBookingLoaded(false);
                      submitResponse(allBookings, handleBookings, ...args).then(r => {
                        getAllBookingsOfUser()
                      })
                    }}
                  />
                </div>)
                :
                (<div>
                    <div hidden={isMobile}>
                      <Carousel
                        autoplay={newBookingsList.length === 0}
                        interval={5000}
                        slides={allBookings.map((job) => (
                          <div
                            className='col-md-9'
                            key={job._id}
                          >
                            <JobComponent
                              job={job}
                              bookings={allBookings}
                              campuses={bookingCampuses}
                              insts={bookingInst}
                              // campuses={allCampus}
                              // insts={allInst}
                              response={true}
                              submitResponse={(...args) => {
                                setBookingLoaded(false);
                                submitResponse(allBookings, handleBookings, ...args).then(r => {
                                  getAllBookingsOfUser();
                                })
                              }}
                            />
                          </div>))}/>
                    </div>
                    <div hidden={!isMobile}>
                      <MobileCarousel
                        adaptiveHeight={true}
                        autoplay={newBookingsList.length === 0}
                        autoplayInterval={5000}
                        renderBottomCenterControls={false}
                        defaultControlsConfig={{
                          nextButtonText: '>',
                          prevButtonText: '<',
                          nextButtonStyle: {
                            backgroundImage: 'linear-gradient(to right, #34f1c8 0%, #3bb4d8 100%)'
                          },
                          prevButtonStyle: {
                            backgroundImage: 'linear-gradient(to right, #34f1c8 0%, #3bb4d8 100%)'
                          }
                        }}
                      >
                        {allBookings.map((job) =>
                          (<div
                            className='col-md-9'
                            key={job._id}
                          >
                            <JobComponent
                              job={job}
                              bookings={allBookings}
                              campuses={bookingCampuses}
                              insts={bookingInst}
                              // campuses={allCampus}
                              // insts={allInst}
                              response={true}
                              submitResponse={(...args) => {
                                setBookingLoaded(false);
                                submitResponse(allBookings, handleBookings, ...args).then(r => {
                                  getAllBookingsOfUser()
                                })
                              }}
                            />
                          </div>))
                        }
                      </MobileCarousel>
                    </div>
                  </div>
              )) : (
              <Spinner small/>
            )}
          </div>

          <div className="mx-4 mt-4">
            <ProfileBox header="Quick Actions">
              <div className="row flex-row mx-2 py-2 quick-action-links">
                <div className="p-2 dashboard-link-teacher">
                  <DashboardLink
                    className="set-availability-link"
                    pathname="/MyCalendar"
                    iconName="calendar plus"
                    text="Set Availability"
                    index={0}
                  />
                </div>

                <div className="p-2 dashboard-link-teacher">
                  <DashboardLink
                    className="view-job-list-link"
                    pathname="/TeacherJobList"
                    iconName="stopwatch"
                    text="View Job List"
                    index={1}
                  />
                </div>

                <div className="p-2 dashboard-link-teacher">
                  <DashboardLink
                    className="search-apply-link"
                    pathname="/JobBoard"
                    iconName="briefcase"
                    text="Search & Apply"
                    index={2}
                  />
                </div>

                <div className="p-2 dashboard-link-teacher">
                  <DashboardLink
                    className="view-inbox-link"
                    pathname="/InboxCustomer"
                    iconName="paper plane"
                    text="View Inbox"
                    index={3}
                    disabledText="Not available"
                  />
                </div>
              </div>
            </ProfileBox>
          </div>

          <div className="recent-feedback py-4">
            <div className="row flex-row mx-1">
              <div className="col-lg-6 recent-feedback">
                <RecentFeedback
                  user={user}
                  badges={badges}
                />
              </div>
              <div className="col-lg-6 recent-feedback">
                <NextExpectedPayment role="teacher" />
              </div>
            </div>
          </div>
        </div>

        {showPaylevelModal && user.role !== 'admin' && !user?.pay_level && user?.is_elt &&
        <Modal
        show={true}
        header="Upload level evidence"
        className="export-booking-modal"
        onClose={() => {
          setShowPaylevelModal(false);
        }}
        >
          <div className="row d-flex flex-column align-items-center text-center">
            <h4>Welcome back!</h4>
            <br/>
            <p>
              We've introduced a new pay level and you are required to provide some new information.
            </p>
            <br/>
            <p>
              Please click on the button below to complete your pay system evidence. We
              need this done before we can assign any new classes to you!
            </p>
            <br/>
            <p>
              Please contact your coordinator if you require any support in the process.
            </p>
            <div className="mt-5 col-md-8 d-flex justify-content-center">
              <a className="btn btn-primary" href="/uploadPayLevel">
                Go to pay system evidence
              </a>
            </div>
          </div>
        </Modal>}
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = function (state, ownProps) {
  return {
    user: state.user.user,
  }
}

export default connect(mapStateToProps)(Dashboard)
